import React, { useState } from 'react'
import { withRouter } from 'react-router'
import { Header, Dropdown, SwitchPersona } from 'packages/eid-ui'
import { Icon } from 'packages/eid-icons'
import { useIsSmallScreen, useUserInfo } from 'packages/core'
import { useTranslation } from 'react-i18next'
import { useCurrentPerson } from 'hooks'
import config from 'config'
import { useConfiguration } from 'appConfiguration'

const AccountDropdown = ({ history }) => {
    const isSmallScreen = useIsSmallScreen()
    const { t } = useTranslation()
    const [open, setOpen] = useState(false)

    const { data: personData } = useCurrentPerson()
    const { data: userInfo } = useUserInfo('/api/v1/me/user')

    const { hasAccessToNotificationSettings } = useConfiguration()

    const content = (
        <span>
            <SwitchPersona
                apiUrl={config.API_URL}
                baseEidUrl={config.BASE_EID_URL}
                actPersonId={userInfo?.actPersonId}
                personId={userInfo?.id}
                associatedLoginsPath="/api/v1/people/AssociatedLogins"
                personLookupPath="/api/v1/people/identities"
                paramType="route"
            />
            {hasAccessToNotificationSettings && (
                <Dropdown.Item
                    tabIndex={0}
                    onClick={() => {
                        history.push(`${config.APP_SUBPATH}/notifications`)
                        setOpen((prev) => !prev)
                    }}
                >
                    <Icon name="EmailNotification" color="#919193" />
                    {t('EmailNotifications')}
                </Dropdown.Item>
            )}
            <Dropdown.Item
                tabIndex={0}
                onClick={() => {
                    history.push('/signout')
                    setOpen((prev) => !prev)
                }}
            >
                <Icon name="LogOut" color="#919193" />
                {t('SignOut')}
            </Dropdown.Item>
        </span>
    )

    const mobile = (
        <Header.AccountDropdown
            photoBase64={personData?.photoBase64}
            imageUrl={`${config.BASE_EID_URL}${personData?.pathToImage}`}
            anchorPosition={{ right: '-32px' }}
            friendlyName={personData?.friendlyName}
            showCone={false}
            open={open}
            handleOpen={setOpen}
        >
            {content}
        </Header.AccountDropdown>
    )

    const desktop = (
        <Header.AccountDropdown
            open={open}
            handleOpen={setOpen}
            photoBase64={personData?.photoBase64}
            friendlyName={personData?.friendlyName}
            imageUrl={`${config.BASE_EID_URL}${personData?.pathToImage}`}
        >
            {content}
        </Header.AccountDropdown>
    )

    return isSmallScreen ? mobile : desktop
}

export default withRouter(AccountDropdown)
